import { useEffect } from 'react';
import { useSettingsContext } from '@/components/settings';
import useResponsive from '@/hooks/useResponsive';

export const NAV_LAYOUT_BEFORE_MIGRATION_KEY = 'cakto:nav-layout-before-migration';

const VERTICAL = 'vertical';

const readStored = () => {
  try {
    return localStorage.getItem(NAV_LAYOUT_BEFORE_MIGRATION_KEY);
  } catch (error) {
    return null;
  }
};

const writeStored = (value) => {
  try {
    if (value) {
      localStorage.setItem(NAV_LAYOUT_BEFORE_MIGRATION_KEY, value);
    } else {
      localStorage.removeItem(NAV_LAYOUT_BEFORE_MIGRATION_KEY);
    }
  } catch (error) {
    // Sem storage o menu so nao volta sozinho ao layout anterior.
  }
};

// O seletor so existe no menu vertical. No desktop, com o menu recolhido (mini)
// ou horizontal, o destaque de migracao nao teria onde se ancorar e a pessoa
// nunca o veria. Enquanto ele estiver pendente, o menu abre no vertical; depois
// do Entendi, volta ao layout que a pessoa usava. O anterior fica guardado para
// a volta acontecer mesmo se a pagina recarregar antes do Entendi.
export default function useNavLayoutForMigration({ pending, settled }) {
  const { themeLayout, onChangeLayout } = useSettingsContext();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (!pending || !isDesktop || themeLayout === VERTICAL) {
      return;
    }

    if (!readStored()) {
      writeStored(themeLayout);
    }

    onChangeLayout({ target: { value: VERTICAL } });
  }, [pending, isDesktop, themeLayout, onChangeLayout]);

  useEffect(() => {
    if (pending || !settled) {
      return;
    }

    const previous = readStored();

    if (!previous) {
      return;
    }

    writeStored(null);

    if (previous !== themeLayout) {
      onChangeLayout({ target: { value: previous } });
    }
  }, [pending, settled, themeLayout, onChangeLayout]);
}
